<div (click)="dialogRef.close()">
    <app-image-view [media_id]="data" [ignoreThumbnail]="true" [proportional]="false"> </app-image-view>
    <div class="img-info" fxLayout="row" fxLayoutAlign="space-between center">
        <button
            class="grey"
            matTooltip="Add to favorite"
            i18n-matTooltip="@@addToFavorite"
            (click)="$event.stopPropagation(); updateFavorite()"
            [ngStyle]="{ color: '#bfd8d0' }"
            mat-icon-button
            fxFlex="0 0 auto"
        >
            <mat-icon>{{ favorite ? 'favorite' : 'favorite_border' }}</mat-icon>
        </button>

        <mat-button-toggle-group
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="10px"
            class="mode-toggle"
            [value]="imgAccess.value"
        >
            <mat-button-toggle
                value="private"
                matTooltip="Private"
                i18n-matTooltip="@@private"
                (click)="$event.stopPropagation(); imgAccess.setValue('private')"
            >
                <span>Private</span>
            </mat-button-toggle>
            <mat-button-toggle
                value="academy"
                matTooltip="Academy"
                i18n-matTooltip="@@academy"
                (click)="$event.stopPropagation(); imgAccess.setValue('academy')"
            >
                <span>Academy</span>
            </mat-button-toggle>
            <mat-button-toggle
                value="library"
                matTooltip="Library"
                i18n-matTooltip="@@library"
                (click)="$event.stopPropagation(); imgAccess.setValue('library')"
            >
                <span>Library</span>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>
